import React from 'react';
const {gridVisualEvidence}=require('./gridExplanation');
export default function SavedGridEvidence({pick,stored,expanded=false}){
 const grid=gridVisualEvidence(pick,pick.gridEvidence??stored);
 if(!grid)return null;
 return <details className="saved-grid" open={expanded||undefined}><summary>See saved Grid for {pick.straight}</summary>
  <table><caption>Verified source draws, oldest to newest</caption><thead><tr><th>Draw</th><th>1st digit</th><th>2nd digit</th><th>3rd digit</th></tr></thead>
   <tbody>{grid.rows.map((r,i)=><tr key={r.date+'-'+i}><th scope="row">{r.date} · {r.session}</th>{r.digits.map((d,j)=><td key={j} className={grid.chosen.rows[j]===i?'chosen-cell':''}>{d}{grid.chosen.rows[j]===i&&<small>Chosen path</small>}</td>)}</tr>)}</tbody>
  </table><p>Saved path: {grid.chosen.digits.join(' → ')} = {pick.straight}. Path agreement is not a winning probability.</p>
 </details>;
}
